import { DateTimeInput, Field } from 'Components/Core';
import { NamePrefixModifier } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetRootComponent } from 'Components/Worksheets/Core';
import { AsDryMassesSection } from 'Components/Worksheets/MoistureContentWorksheet/As/1289_2_1_1/Sections';

let AsMeasuredConstantDryMassWorksheet: WorksheetRootComponent = () => (
  <>
    <NamePrefixModifier appendNamePrefix="OversizeCorrectionData.OversizeCorrectionConstantDryMass">
      <ListFieldSection>
        <Field input={<DateTimeInput />} name="DryingTray.DateTimePlacedInOvenLocal" />
      </ListFieldSection>
      <AsDryMassesSection />
    </NamePrefixModifier>
  </>
);

export default AsMeasuredConstantDryMassWorksheet;
export { AsMeasuredConstantDryMassWorksheet };
